<template>
    <div class="content">
        <h1>WILLKOMMEN</h1>
        <p>
            Der Zeitpunkt unserer Geburt, an dem - in Bezug zu unserem Geburtsort auf der Erde - 
            die individuelle Konstellation aus Sonne, Mond und den Planeten unseres Sonnensystems gebildet wurde, 
            ist für unser ganzes Leben von Richtung weisender Bedeutung.
        </p>
        <p>
            So wie der Mond es zustande bringt, durch das Zusammenspiel seines Magnetismus' 
            mit dem der Erde Einfluss auf die Rhythmen von Ebbe und Flut und auf die Regel der Frau zu nehmen, 
            und wie es ohne Sonne gar kein Leben auf diesem Planeten gäbe, 
            so haben alle Planeten unseres Sonnensystems zusammen mit uns als menschlichen Wesen 
            Teil am energetischen Wechselspiel der Kräfte und dienen so als kosmischer Spiegel unserer 
            individuellen Persönlichkeitsanlagen.
        </p>
        <h1>HOROSKOPE</h1>
        <p>
            Kennen Sie Ihren Aszendenten? Wissen Sie, in welchem Zeichen Ihr Mond steht?<br/>
            Lassen Sie sich ganz einfach Ihre eigene <router-link to="/shop">Horoskop-Analyse</router-link> erstellen...
        </p>
        <img :src="horoscopeHomeImg" class="horoscope-img" />
        <p>
            Die hier erhältlichen Analysen stammen aus den Federn der erfahrenen Astrologen
            Dr. Eike Hansen und Susanne Christan.
        </p>
        <h1>SHOP</h1>
        <p>
            Im Shop finden Sie
            <ul>
                <li>Persönlichkeits-Analysen</li>
                <li>Partner-Analysen</li>
                <li>Kinder-Analysen</li>
                <li>Geburts-Horoskopgrafiken</li>
                <li>Partner-Horoskopgrafiken</li>
                <li>Differenziertes Datenblatt zum Geburtshoroskop</li>
            </ul>
        </p>
        <button
            class="btn btn-success btn-to-shop"
            @click="toShop()">
            <i class="fas fa-shopping-bag"></i>Zum Shop
        </button>
        <!--
        <h1>Ihr eigenes Horoskop</h1>
        <p>
            Lassen Sie sich kostenfrei ihr eigenes Horoskop berechnen.
        </p>
        <button
            class="btn btn-success btn-to-horosokop"
            @click="toHoroskop()">
            <i class="fas fa-venus-mars"></i>Horoskop berechnen
        </button>
        //-->
    </div>
</template>

<script>
import siteConfig from '@/assets/js/mixins/siteConfig';

export default {
    name: 'Home',
    mixins: [
        siteConfig
    ],
    data() {
        return {
            horoscopeHomeImg: siteConfig.previewUrl + 'dali-min.jpg'
        };
    },
    methods: {
        toShop() {
            this.emitLogData('home', 'toShopButton');
            this.$router.push({ path: 'shop' });
        },

        toHoroskop() {
            this.emitLogData('home', 'toHoroskopButton');
            this.$router.push({ path: 'horoskop' });
        },

        emitLogData(page, action) {
            this.$emit(
                'log-it',
                '{"page": "' + page + '", "action": "' + action + '"}'
            );
        }
    },
    mounted() {
        this.emitLogData('home', 'visit');
    },
    beforeDestroy() {
        this.emitLogData('home', 'leave');
    }
};
</script>

<style lang="scss" scoped>
    h3 {
        margin: 40px 0 0;
    }
    ul {
        padding: 0;
        margin-left: 10px;
    }
    li {
        margin: 0 10px;
    }
    a {
        color: #42b983;
    }
    .btn-to-shop {
        margin: 5px 0 25px 0;
    }
    .fas {
        margin-right: 10px;
    }
    .horoscope-img {
        margin-bottom: 20px;
        max-width: 800px;
    }
    .beta {
        color: coral;
        border: 1px solid coral;
        -webkit-border-radius: 0.25rem;
        -moz-border-radius: 0.25rem;
        border-radius: 0.25rem;
        padding: 10px;
        margin: 10px 0;
    }
</style>
